import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MeService } from '@client/app/services/entities/me/me.service';
import { SessionService } from '@monsido/core/session/session.service';
import { TotalDomainsService } from '@client/app/services/total-domains/total-domains.service';

@Component({
    selector: 'pin-domain',
    standalone: false,
    template: `
        <div class="pin-domain page-title">
            <div class="url-title-link outer-b-smurf text-nowrap d-flex align-items-center">
                <div *ngIf="showDomainIcon">
                    <a (click)="goto.emit(model)"
                       tabindex="-1"
                       [attr.title]="model.title">
                        <span monFaviconWrapperComponent
                            [monSrc]="'https://www.google.com/s2/favicons?domain=' + model.url"
                            [monAlt]="('Domain favicon for ' | translate) + model.title"
                        ></span>
                    </a>
                </div>
                <a (click)="goto.emit()"
                   class="text-link text-ellipsis mx-1 p-0"
                   [ngClass]="disabled ? 'cursor-not-allowed' : 'cursor-pointer'">
                   {{ model.title }}
                </a>
                <a data-test="unpin-domain-link"
                   [attr.title]="'Unpin domain' | translate"
                   *ngIf="model.favorite"
                   [monModalConfirm]="'Are you sure you want to unpin this domain' | translate"
                   (monModalConfirmAction)="handlePinClick()"
                   (click)="stopPro($event)"
                   (keydown)="stopPro($event)"
                   tabindex="-1"
                   class="cursor-pointer"
                >
                    <span class="fas fa-star domain-pin-pined" aria-hidden="true"></span>
                </a>

                <a [attr.title]="'Pin domain' | translate"
                   data-test="pin-domain-link"
                   (keydown)="stopPro($event)"
                   (click)="handlePinClick($event)"
                   tabindex="-1"
                   *ngIf="!model.favorite && (active || adaMode)"
                   [ngbPopover]="'You can pin this domain. Pinned domains will be shown at the top of your domain list' | translate"
                   [popoverTitle]="'Pin domain' | translate"
                   triggers="mouseenter"
                   popoverClass="popover-bs3"
                   class="cursor-pointer"
                >
                    <span class="far fa-star text-dark-grey domain-pin-not-pined"></span>
                </a>
            </div>
            <div class="tooltip_url text-nowrap text-ellipsis">
                <a *ngIf="model.url"
                   [href]="model.url"
                   target="_blank"
                   aria-describedby="linkOpensInNewTab"
                   [attr.title]="'Go to page' | translate"
                   tabindex="-1">
                    <span aria-hidden="true" class="fa fa-external-link"></span>
                </a>
                <span *ngIf="model.url" class="link-tooltip">{{ model.url }}</span>
                <span *ngIf="!model.url" class="text-italic" translate>Unable to read link</span>
            </div>
        </div>
    `,
})
export class PinDomainComponent implements OnInit {
    @Input() model: any;
    @Input() active: any;
    @Input() showDomainIcon: any;
    @Input() disabled: boolean = false;

    @Output() goto = new EventEmitter<void>();
    @Output() modelChange = new EventEmitter<any>();
    @Output() callback = new EventEmitter<void>();

    adaMode: any;

    constructor (
        private meService: MeService,
        private sessionService: SessionService,
        private totalDomainsService: TotalDomainsService,
    ) {
    }

    ngOnInit (): void {
        this.adaMode = this.sessionService.adaMode();
    }

    handlePinClick (ev?: Event): void {
        if (ev !== undefined) {
            ev.stopPropagation();
        }

        const domains = this.totalDomainsService.domainsEssential.getValue();
        const domain = domains?.find((currentDomain) => currentDomain.id === this.model.id);
        if (domain) {
            domain.favorite = !this.model.favorite;
            this.totalDomainsService.updateDomain(domain);
        }

        this.meService.updateDomain(this.model.id, { favorite: !this.model.favorite }).then((data) => {
            this.model.favorite = data.favorite;
            this.modelChange.emit(this.model);
            this.callback.emit();
        }, () => {});
    }

    stopPro (ev: Event): void {
        ev.stopPropagation();
    }
}
